"use client";

import { useEffect, useState } from "react";
import { Heart, ArrowRight, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NaoObrigado() {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Scroll to top quando a página carregar
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // Countdown para redirecionamento automático
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      // Redirecionar após countdown
      window.location.href = "/obrigado";
    }
  }, [countdown]);

  const handleContinue = () => {
    window.location.href = "/obrigado";
  };

  return (
    <main className="relative min-h-screen w-full overflow-hidden flex items-center justify-center px-4">
      {/* Background animado */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-primary">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary/30 rounded-full blur-[100px] motion-safe:animate-glow-pulse" aria-hidden />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent/20 rounded-full blur-[100px] motion-safe:animate-glow-pulse" style={{ animationDelay: "2s" }} aria-hidden />
      </div>

      {/* Grid background */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.03] [mask-image:radial-gradient(70%_70%_at_50%_50%,black,transparent)]"
        style={{
          backgroundImage:
            "linear-gradient(to right, hsl(var(--border)) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--border)) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      {/* Conteúdo */}
      <div className="relative z-10 w-full max-w-3xl">
        <div className="text-center space-y-8 motion-safe:animate-fade-in">
          {/* Ícone */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-accent/20 rounded-full blur-2xl animate-pulse" />
              <div className="relative bg-gradient-to-br from-primary/30 to-accent/30 rounded-full p-6">
                <Heart className="w-16 h-16 text-accent" />
              </div>
            </div>
          </div>

          {/* Título Principal */}
          <div className="space-y-4">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black leading-tight">
              Tudo bem,
              <span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(100,192,242,0.6)]">
                {" "}respeitamos sua decisão
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              O importante é que você deu o primeiro passo. 
              Estamos aqui para te apoiar no que você decidir fazer.
            </p>
          </div>

          {/* Card de mensagem */}
          <div className="bg-gradient-to-br from-primary/10 to-accent/5 border border-primary/30 rounded-2xl p-8 md:p-10 space-y-6 max-w-2xl mx-auto">
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p className="text-lg">
                Entendemos que cada pessoa tem seu próprio tempo e suas próprias circunstâncias.
              </p>
              <p className="text-lg">
                O conteúdo que você adquiriu já vai fazer diferença na sua jornada. 
                Use-o bem e lembre-se: estamos sempre aqui caso precise de mais apoio no futuro.
              </p>
              <p className="text-lg font-semibold text-foreground">
                Boa sorte na sua transformação! 💪
              </p>
            </div>
          </div>

          {/* Contador e botão */}
          <div className="space-y-6">
            <div className="flex items-center justify-center gap-2 text-muted-foreground">
              <Clock className="w-5 h-5" />
              <span>Redirecionando em {countdown} segundos...</span>
            </div>

            <Button
              variant="hero"
              size="xl"
              onClick={handleContinue}
              className="group"
            >
              Continuar agora
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
}
